import { render, staticRenderFns } from "./messageBox.vue?vue&type=template&id=124af6c3&scoped=true"
import script from "./messageBox.vue?vue&type=script&lang=js"
export * from "./messageBox.vue?vue&type=script&lang=js"
import style0 from "./messageBox.vue?vue&type=style&index=0&id=124af6c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124af6c3",
  null
  
)

export default component.exports